export {default as schemeCategory10} from "./categorical/category10";
export {default as schemeAccent} from "./categorical/Accent";
export {default as schemeDark2} from "./categorical/Dark2";
export {default as schemePaired} from "./categorical/Paired";
export {default as schemePastel1} from "./categorical/Pastel1";
export {default as schemePastel2} from "./categorical/Pastel2";
export {default as schemeSet1} from "./categorical/Set1";
export {default as schemeSet2} from "./categorical/Set2";
export {default as schemeSet3} from "./categorical/Set3";
export {default as interpolateBrBG, scheme as schemeBrBG} from "./diverging/BrBG";
export {default as interpolatePRGn, scheme as schemePRGn} from "./diverging/PRGn";
export {default as interpolatePiYG, scheme as schemePiYG} from "./diverging/PiYG";
export {default as interpolatePuOr, scheme as schemePuOr} from "./diverging/PuOr";
export {default as interpolateRdBu, scheme as schemeRdBu} from "./diverging/RdBu";
export {default as interpolateRdGy, scheme as schemeRdGy} from "./diverging/RdGy";
export {default as interpolateRdYlBu, scheme as schemeRdYlBu} from "./diverging/RdYlBu";
export {default as interpolateRdYlGn, scheme as schemeRdYlGn} from "./diverging/RdYlGn";
export {default as interpolateSpectral, scheme as schemeSpectral} from "./diverging/Spectral";
export {default as interpolateBuGn, scheme as schemeBuGn} from "./sequential-multi/BuGn";
export {default as interpolateBuPu, scheme as schemeBuPu} from "./sequential-multi/BuPu";
export {default as interpolateGnBu, scheme as schemeGnBu} from "./sequential-multi/GnBu";
export {default as interpolateOrRd, scheme as schemeOrRd} from "./sequential-multi/OrRd";
export {default as interpolatePuBuGn, scheme as schemePuBuGn} from "./sequential-multi/PuBuGn";
export {default as interpolatePuBu, scheme as schemePuBu} from "./sequential-multi/PuBu";
export {default as interpolatePuRd, scheme as schemePuRd} from "./sequential-multi/PuRd";
export {default as interpolateRdPu, scheme as schemeRdPu} from "./sequential-multi/RdPu";
export {default as interpolateYlGnBu, scheme as schemeYlGnBu} from "./sequential-multi/YlGnBu";
export {default as interpolateYlGn, scheme as schemeYlGn} from "./sequential-multi/YlGn";
export {default as interpolateYlOrBr, scheme as schemeYlOrBr} from "./sequential-multi/YlOrBr";
export {default as interpolateYlOrRd, scheme as schemeYlOrRd} from "./sequential-multi/YlOrRd";
export {default as interpolateBlues, scheme as schemeBlues} from "./sequential-single/Blues";
export {default as interpolateGreens, scheme as schemeGreens} from "./sequential-single/Greens";
export {default as interpolateGreys, scheme as schemeGreys} from "./sequential-single/Greys";
export {default as interpolatePurples, scheme as schemePurples} from "./sequential-single/Purples";
export {default as interpolateReds, scheme as schemeReds} from "./sequential-single/Reds";
export {default as interpolateOranges, scheme as schemeOranges} from "./sequential-single/Oranges";
export {default as interpolateCubehelixDefault} from "./sequential-multi/cubehelix";
export {default as interpolateRainbow, warm as interpolateWarm, cool as interpolateCool} from "./sequential-multi/rainbow";
export {default as interpolateSinebow} from "./sequential-multi/sinebow";
export {default as interpolateViridis, magma as interpolateMagma, inferno as interpolateInferno, plasma as interpolatePlasma} from "./sequential-multi/viridis";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale-chromatic/src/index.js
// module id = 476
// module chunks = 0